import type { ICookiesClient } from "@tiendeo/cookies";
import type { IConfig } from "config/IConfig";
import { EMBEDDED_WEBVIEW_COOKIE, ORIGIN, APP_VERSION } from "cookies/cookiesConstants";
import get from "lodash/get";
import noop from "lodash/noop";

interface NativeCallback {
    androidParameters: any[];
    iosParameters: any[];
    androidCallbackName: string;
    iosCallbackName: string;
}

class WebviewService {
    constructor(private cookies: ICookiesClient, configs: IConfig) {
        if (typeof window === "undefined") {
            return;
        }

        // tslint:disable-next-line: no-string-literal
        window["androidObj"] = {};
    }

    public IsWebView = () => !!this.cookies.Get(EMBEDDED_WEBVIEW_COOKIE);

    public IsAndroid = () => this.cookies.Get(ORIGIN) === "android";

    public IsIos = () => this.cookies.Get(ORIGIN) === "ios";

    public GetAppVersion = () => this.cookies.Get(APP_VERSION);

    public Configuration() {
        this.sendNativeCallback({
            androidCallbackName: "onSettingsSelected",
            androidParameters: [],
            iosCallbackName: "onSettingsSelectedMessageHandler",
            iosParameters: [{}],
        });
    }

    public Cuts() {
        this.sendNativeCallback({
            androidCallbackName: "onMyListSelected",
            androidParameters: [],
            iosCallbackName: "onMyListSelectedMessageHandler",
            iosParameters: [{}],
        });
    }

    public Cards() {
        this.sendNativeCallback({
            androidCallbackName: "onLoyaltyCardsSelected",
            androidParameters: [],
            iosCallbackName: "onLoyaltyCardsSelectedMessageHandler",
            iosParameters: [{}],
        });
    }

    public Favorites() {
        this.sendNativeCallback({
            androidCallbackName: "onFavoritesSelected",
            androidParameters: [],
            iosCallbackName: "onFavoritesSelectedMessageHandler",
            iosParameters: [{}],
        });
    }

    public Login() {
        this.sendNativeCallback({
            androidCallbackName: "startLogin",
            androidParameters: [],
            iosCallbackName: "startLoginMessageHandler",
            iosParameters: [{}],
        });
    }

    public Logout() {
        this.sendNativeCallback({
            androidCallbackName: "logout",
            androidParameters: [],
            iosCallbackName: "logoutMessageHandler",
            iosParameters: [{}],
        });
    }

    public RecommendTiendeo() {
        this.sendNativeCallback({
            androidCallbackName: "onRecommendSelected",
            androidParameters: [],
            iosCallbackName: "onRecommendSelectedMessageHandler",
            iosParameters: [{}],
        });
    }

    public StoreReview() {
        this.sendNativeCallback({
            androidCallbackName: "onScoreInStoreSelected",
            androidParameters: [],
            iosCallbackName: "onScoreInStoreSelectedMessageHandler",
            iosParameters: [{}],
        });
    }

    public DeleteAccount() {
        this.sendNativeCallback({
            androidCallbackName: "onDeleteAccountSelected",
            androidParameters: [],
            iosCallbackName: "onDeleteAccountSelectedMessageHandler",
            iosParameters: [{}],
        });
    }

    public Help() {
        this.sendNativeCallback({
            androidCallbackName: "onHelpSelected",
            androidParameters: [],
            iosCallbackName: "onHelpSelectedMessageHandler",
            iosParameters: [{}],
        });
    }

    private sendNativeCallback(nativeCallback: NativeCallback) {
        if (typeof window === "undefined" || !this.IsWebView()) {
            return;
        }
        /* Android */
        const androidCallback = get(
            window,
            `androidObj.${nativeCallback.androidCallbackName}`,
            noop,
        );
        androidCallback(...nativeCallback.androidParameters);

        /* IOS */
        try {
            // The empty object in the postMessage is necessary. Do not delete.
            // @ts-ignore
            window.webkit.messageHandlers[nativeCallback.iosCallbackName].postMessage(
                ...nativeCallback.iosParameters,
            );
        } catch (e) {}

        return;
    }
}

export default WebviewService;
